import { useUpdateFilters } from '@services/filters/update';
import { useFilterKey } from './useFilterKey';
import { Filters } from '@services/filters/types';
import { useAppContext } from '@contexts/app';
import isEqual from 'deep-equal';
import { useDebouncedCallback } from 'use-debounce';
import { QueryParam, QueryParams } from './queryParams/types';

const EXCLUDED_KEYS: QueryParam[] = [
  'date',
  'tab',
  'page',
  'focus',
  'exchange',
  'open',
  'expired',
] as const;
const SAVE_DEBOUNCE_DELAY = 400;

export const useSaveFilters = () => {
  const key = useFilterKey();
  const { mutate } = useUpdateFilters();
  const { filters } = useAppContext();

  const debouncedMutate = useDebouncedCallback((data: Filters) => {
    mutate({ data });
  }, SAVE_DEBOUNCE_DELAY);

  return (newFilters: QueryParams) => {
    const params = { ...newFilters };

    EXCLUDED_KEYS.forEach((el) => {
      delete params[el];
    });

    Object.keys(params).forEach((el) => {
      const paramKey = el as keyof QueryParams;
      if (!params[paramKey]?.length) delete params[paramKey];
    });

    if (!filters || !key || isEqual(filters?.[key], params)) return;
    debouncedMutate({ ...filters, [key]: params } as Filters);
  };
};
